import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=765cf74e&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=765cf74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765cf74e",
  null
  
)

export default component.exports